import { createStore, applyMiddleware } from 'redux';
import reducers from './reducers';

const store = createStore(reducers, window['__REDUX_DEVTOOLS_EXTENSION__'] && window['__REDUX_DEVTOOLS_EXTENSION__'](), applyMiddleware(py3Debug));


function py3Debug({getState}){
    return (next) => (action) => {

        window['py3DebugActions'] = window['py3DebugActions'] || [];
        window['py3DebugActions'].push(action);
        window['py3DebugState'] = (getState());

        return next(action);
    };
}

export default store;


// WEBPACK FOOTER //
// ./source/ts/store/store.ts